import styled from 'styled-components';
import { Row, Button } from 'antd';

const TechnicianContainer = styled.div`
  display: flex; 
  flex-direction: column; 
  padding: 10px; 
  margin: 5px 0px; 
  border: 2px solid #d9d9d9; 
  border-radius: 15px;
  width: 32%;
  max-width: 33%;
  cursor: pointer;
`;
const ListTechnicianContainer = styled(Row)`
  justify-content: space-between;
`;

const ButtonLink = styled(Button)`
  max-width: fit-content;
  padding: 0px;
`;

  
export { TechnicianContainer, ListTechnicianContainer,ButtonLink };
